import React from 'react';
import { Linkedin, ArrowUp, MapPin } from 'lucide-react';
import { companyInfo, footerLinks } from '../../data/mock';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_71122495-5c3a-44f9-81bc-14be3cbb18e4/artifacts/cv5kk375_sportiva-infotech%20logo.png";

export const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#1e3a5f] text-white">
      {/* CTA Section */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="text-center">
            <h2 className="text-2xl sm:text-3xl font-bold mb-4">
              Ready to Transform Your Digital Presence?
            </h2>
            <p className="text-white/70 mb-8 max-w-xl mx-auto">
              Let's discuss how we can help you build scalable digital solutions that drive growth.
            </p>
            <button
              onClick={() => scrollToSection('#contact')}
              className="px-8 py-4 bg-[#f26522] hover:bg-[#d95a1b] text-white font-medium rounded-xl transition-all hover:shadow-lg hover:shadow-[#f26522]/30 hover:-translate-y-0.5"
            >
              Start Your Project Today
            </button>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-10">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-white rounded-lg p-2">
                <img 
                  src={LOGO_URL} 
                  alt="Sportiva Infotech" 
                  className="h-12 sm:h-14 w-auto object-contain"
                />
              </div>
            </div>
            <p className="text-white/70 leading-relaxed max-w-md mb-6">
              {companyInfo.description}
            </p>
            <div className="flex items-center gap-4">
              <a
                href={companyInfo.socials.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center hover:bg-[#f26522] transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-white mb-4">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-white/70 hover:text-[#f26522] transition-colors text-sm"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-white mb-4">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-white/70 hover:text-[#f26522] transition-colors text-sm"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-white mb-4">Contact</h4>
            <div className="space-y-3 text-white/70 text-sm">
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0 text-[#f26522]" />
                <div>
                  <span className="block text-white/50 text-xs mb-1">Location</span>
                  <span className="leading-relaxed">{companyInfo.location}</span>
                </div>
              </div>
            </div>
            
            {/* Legal Links */}
            <div className="mt-6 pt-4 border-t border-white/10">
              {footerLinks.legal.map((link, i) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-white/50 hover:text-white/70 text-xs transition-colors mr-4"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-white/50 text-sm">
              © {new Date().getFullYear()} {companyInfo.copyrightName}. All rights reserved.
            </p>
            <button
              onClick={scrollToTop}
              className="flex items-center gap-2 text-white/70 hover:text-white transition-colors text-sm"
            >
              Back to top
              <ArrowUp className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};
